import { createMuiTheme, responsiveFontSizes } from '@material-ui/core';
import { light, dark } from './palette';

const getTheme = mode =>
  responsiveFontSizes(
    createMuiTheme({
      overrides: {
        MuiTooltip: {
          tooltip: {
            fontSize: '1em',
            backgroundColor: '#293a42',
            color: '#fff',
          },
        },
      },
      palette: mode === 'light' ? light : dark,

      layout: {
        contentWidth: 1280,
      },
      typography: {
        fontFamily: 'Roboto',
        button: {
          textTransform: 'none',
        },
      },
      zIndex: {
        appBar: 1200,
        drawer: 1100,
      },
    }),
  );

export default getTheme;
